/**
 * As tabelas da sala que vêm com o RPG Desk (docs/spec/tables-dock.md, "Tabelas embutidas"): o
 * Tracker de Combate e as Macros. Toda mesa tem as duas, ativas, e elas abrem pelo menu Painéis
 * como os outros painéis (docs/spec/room-menus.md). As de plugin continuam sendo ativadas pelo
 * mestre nas Configurações da mesa.
 */
import { COMBAT_TRACKER } from './combatLink.js';

/** O tipo de dado da tabela "Macros". */
export const MACROS_PANEL = 'rpgdesk:macros';

export const BUILTIN_TABLES: readonly string[] = [COMBAT_TRACKER, MACROS_PANEL];

export const isBuiltinTable = (dataType: string | null | undefined): boolean => !!dataType && BUILTIN_TABLES.includes(dataType);
